'use client';
import styles from './info-track.module.scss';
import {useAppDispatch, useAppSelector} from 'store/hooks';
import {getPlayer} from 'store/slices/player.slices';
import {useEffect, useRef, useState} from 'react';
import {SSRFetch} from "../../../../../services/ssr-fetch.services";
import {GET_BROADCASTS} from "../../../../../libs/constants/api";

interface IBroadcast {
    broadcastUrl: string,
    broadcastCurrentPlayingName: string | null
    error: string | null
}

export const InfoTrack = () => {
    const dispatch = useAppDispatch()

    const [sizeImage, setSizeImage] = useState(150);
    const [informationBroadcast, setInformationBroadcast] = useState('')
    const [sizeWindow, setSizeWindow] = useState(false)
    const {nameTrack, description, cover} = useAppSelector(getPlayer);
    const refInterval = useRef(null)


    useEffect(() => {
        if (nameTrack === 'Прямой эфир') {
            refInterval.current = setInterval(() => {
                SSRFetch<IBroadcast>(GET_BROADCASTS).then(res => {
                    setInformationBroadcast(res.broadcastCurrentPlayingName)
                })
            }, 5000)
        } else {
            clearInterval(refInterval.current)
            setInformationBroadcast('')
        }
    }, [nameTrack])

    /* Адаптивно меняет передаваемый размер изображения */
    useEffect(() => {
        let newSizeImage;
        if (window.innerWidth >= 993) {
            newSizeImage = 12 + (16 - 12) * ((window.innerWidth - 320) / (1440 - 320));
        } else {
            newSizeImage = 12 + (16 - 12) * ((window.innerWidth - 320) / (1440 - 320));
        }

        if (window.innerWidth <= 639) {
            setSizeWindow(true)
        }
        setSizeImage(9.375 * newSizeImage);
    }, []);

    return (
        <section className={styles.info}>
            <div className={styles.wrap}>
                <img
                    className={styles.icon}
                    height={sizeImage}
                    width={sizeImage}
                    src={cover.url}
                    alt={nameTrack}
                />
            </div>
            {sizeWindow ? <div className={styles.infoTrack}>
                <h6 className={styles.title}>{nameTrack}</h6>
                <p className={`${styles.description} ${nameTrack === 'Прямой эфир' ? styles.informationBroadcast : ''}`}>
                    {informationBroadcast || description}
                </p>
            </div> : <>
                <h6 className={styles.title}>{nameTrack}</h6>
                <p className={`${styles.description} ${nameTrack === 'Прямой эфир' ? styles.informationBroadcast : ''}`}>
                    {informationBroadcast || description}
                </p>
            </>}


        </section>
    );
};
